export default __webpack_public_path__ + "static/media/treemap-chart.e2c9f480.svg";